import type { Listeners } from '../helpers';
import { controllerHelpers } from '../helpers';
import { routerNonUiEventBus } from '../managers';
import type { PayflowProgressBarManager } from '../managers';

export class RouterNonUiController {
  public listeners: Listeners;

  constructor(private payflowProgressBarManager: PayflowProgressBarManager) {
    this.listeners = controllerHelpers.createListeners([
      routerNonUiEventBus.bindTo('routePopped', this.onRouteChanged),
    ]);
  }

  private onRouteChanged = async (pathname: string) => {
    const api = await this.payflowProgressBarManager.getApiWhenReady();

    switch (pathname) {
      case '/purchase/plans-and-pricing':
        api.setStepToPlans();
        break;

      case '/purchase/add-ons':
        api.setStepToAddOns();
        break;

      case '/purchase/checkout':
        api.setStepToCheckout();
        break;

      default:
        break;
    }
  };
}
